import React from "react";

import Banner from "../Banner";

import styles from "./RightFixedBanner.scss";

import * as advertisingService from "../../bl/advertisingService";

class RightFixedBanner extends React.Component {
  componentDidMount() {
    setTimeout(advertisingService.rotateAdvertising, 300);

  }

  render() {
    return (
      <div id="doc1501_max" className={styles.docPosition1501Max}>
        <Banner docPreset="allpages_300_300" minScreenWidth={1484} docCloseType="2" />
      </div>
    );
  }
}

export default RightFixedBanner;
